export const CLASS_FORM_NEXT_STEP = 'CLASS_FORM_NEXT_STEP';
export const CLASS_FORM_GOTO_STEP = 'CLASS_FORM_GOTO_STEP';
export const CLASS_FORM_RESET = 'CLASS_FORM_RESET';
export const CLASS_FORM_SET_CLASS_NAME = 'CLASS_FORM_SET_CLASS_NAME';
export const CLASS_FORM_SET_INSTRUCTOR_ID = 'CLASS_FORM_SET_INSTRUCTOR_ID';
export const CLASS_FORM_SET_LOCATION_ID = 'CLASS_FORM_SET_LOCATION_ID';
export const CLASS_FORM_SET_CLASS_DESCRIPTION = 'CLASS_FORM_SET_CLASS_DESCRIPTION';
export const CLASS_FORM_SET_GRADE = 'CLASS_FORM_SET_GRADE';
export const CLASS_FORM_SET_AGE = 'CLASS_FORM_SET_AGE';
export const CLASS_FORM_SET_GRADE_FROM = 'CLASS_FORM_SET_GRADE_FROM';
export const CLASS_FORM_SET_GRADE_TO = 'CLASS_FORM_SET_GRADE_TO';
export const CLASS_FORM_SET_AGE_FROM = 'CLASS_FORM_SET_AGE_FROM';
export const CLASS_FORM_SET_AGE_TO = 'CLASS_FORM_SET_AGE_TO';
export const CLASS_FORM_SET_FORM_VALID = 'CLASS_FORM_SET_FORM_VALID';
export const CLASS_FORM_SET_WEEK_DAYS = 'CLASS_FORM_SET_WEEK_DAYS';
export const CLASS_FORM_SET_CLASS_START_DATE = 'CLASS_FORM_SET_CLASS_START_DATE';
export const CLASS_FORM_SET_CLASS_END_DATE = 'CLASS_FORM_SET_CLASS_END_DATE';
export const CLASS_FORM_SET_NO_CLASS_DATES = 'CLASS_FORM_SET_NO_CLASS_DATES';
export const CLASS_FORM_SET_TIME_FROM = 'CLASS_FORM_SET_TIME_FROM';
export const CLASS_FORM_SET_TIME_TO = 'CLASS_FORM_SET_TIME_TO';
export const CLASS_FORM_SET_SIGN_UP_BEGINS_DATE = 'CLASS_FORM_SET_SIGN_UP_BEGINS_DATE';
export const CLASS_FORM_SET_SIGN_UP_ENDS_DATE = 'CLASS_FORM_SET_SIGN_UP_ENDS_DATE';
export const CLASS_FORM_SET_SIGN_UP_BEGINS_TIME = 'CLASS_FORM_SET_SIGN_UP_BEGINS_TIME';
export const CLASS_FORM_SET_SIGN_UP_ENDS_TIME = 'CLASS_FORM_SET_SIGN_UP_ENDS_TIME';
export const CLASS_FORM_SET_PRICE = 'CLASS_FORM_SET_PRICE';
export const CLASS_FORM_SET_PRORATE = 'CLASS_FORM_SET_PRORATE';
export const CLASS_FORM_SET_PICKUP_OPTIONS = 'CLASS_FORM_SET_PICKUP_OPTIONS';
export const CLASS_FORM_SET_PICKUP_OPTIONS_REQUIRED = 'CLASS_FORM_SET_PICKUP_OPTIONS_REQUIRED';
export const CLASS_FORM_SET_TEACHER = 'CLASS_FORM_SET_TEACHER';
export const CLASS_FORM_SET_TEACHER_REQUIRED = 'CLASS_FORM_SET_TEACHER_REQUIRED';
export const CLASS_FORM_SET_T_SHIRT = 'CLASS_FORM_SET_T_SHIRT';
export const CLASS_FORM_SET_T_SHIRT_REQUIRED = 'CLASS_FORM_SET_T_SHIRT_REQUIRED';
export const CLASS_FORM_SET_BILLING_TYPE = 'CLASS_FORM_SET_BILLING_TYPE';
export const CLASS_FORM_SET_WAILT_LIST = 'CLASS_FORM_SET_WAIT_LIST';
export const CLASS_FORM_SET_MAX_ENROLL = 'CLASS_FORM_SET_MAX_ENROLL';
export const CLASS_FORM_SET_MAX_WAIT_LIST = 'CLASS_FORM_SET_MAX_WAIT_LIST';
export const CLASS_FORM_ADD_ADDON = 'CLASS_FORM_ADD_ADDON';
export const CLASS_FORM_SET_ADDON_NAME = 'CLASS_FORM_SET_ADDON_NAME';
export const CLASS_FORM_SET_ADDON_PRICE = 'CLASS_FORM_SET_ADDON_PRICE';
export const CLASS_FORM_SET_ADDON_REQUIRED = 'CLASS_FORM_SET_ADDON_REQUIRED';
export const CLASS_FORM_SET_ADDON_DISCOUNT = 'CLASS_FORM_SET_ADDON_DISCOUNT';
export const CLASS_FORM_SET_ADDON_MAX_AMOUNT = 'CLASS_FORM_SET_ADDON_MAX_AMOUNT';
export const CLASS_FORM_REMOVE_ADDON = 'CLASS_FORM_REMOVE_ADDON';
export const CLASS_FORM_SET_MULTI_CHILD_DISCOUNT_BONUS_TYPE = 'CLASS_FORM_SET_MULTI_CHILD_DISCOUNT_BONUS_TYPE';
export const CLASS_FORM_SET_MULTI_CHILD_DISCOUNT_AMOUNT = 'CLASS_FORM_SET_MULTI_CHILD_DISCOUNT_AMOUNT';
export const CLASS_FORM_SET_MULTI_CHILD_DISCOUNT_NUMBER_OF_KIDS = 'CLASS_FORM_SET_MULTI_CHILD_DISCOUNT_NUMBER_OF_KIDS';
export const CLASS_FORM_SET_MULTI_CHILD_DISCOUNT_ACTIVE = 'CLASS_FORM_SET_MULTI_CHILD_DISCOUNT_ACTIVE';
export const CLASS_FORM_SET_FIRST_CHILD_DISCOUNT = 'CLASS_FORM_SET_FIRST_CHILD_DISCOUNT';
export const CLASS_FORM_SET_MULTI_PROGRAM_DISCOUNT_BONUS_TYPE = 'CLASS_FORM_SET_MULTI_PROGRAM_DISCOUNT_BONUS_TYPE';
export const CLASS_FORM_SET_MULTI_PROGRAM_DISCOUNT_AMOUNT = 'CLASS_FORM_SET_MULTI_PROGRAM_DISCOUNT_AMOUNT';
export const CLASS_FORM_SET_MULTI_PROGRAM_DISCOUNT_NUMBER_OF_KIDS = 'CLASS_FORM_SET_MULTI_PROGRAM_DISCOUNT_NUMBER_OF_KIDS';
export const CLASS_FORM_SET_MULTI_PROGRAM_DISCOUNT_ACTIVE = 'CLASS_FORM_SET_MULTI_PROGRAM_DISCOUNT_ACTIVE';
export const CLASS_FORM_SET_EARLY_BIRD_PAYMENT_TYPE = 'CLASS_FORM_SET_EARLY_BIRD_PAYMENT_TYPE';
export const CLASS_FORM_SET_EARLY_BIRD_AMOUNT = 'CLASS_FORM_SET_EARLY_BIRD_AMOUNT';
export const CLASS_FORM_SET_EARLY_BIRD_END_DATE = 'CLASS_FORM_SET_END_DATE';
export const CLASS_FORM_SET_EARLY_BIRD_ACTIVE = 'CLASS_FORM_SET_EARLY_BIRD_ACTIVE';
export const CLASS_FORM_SET_TYPE = 'CLASS_FORM_SET_TYPE';
export const CLASS_FORM_SET_DISCOUNTS_OPENED = 'CLASS_FORM_SET_DISCOUNTS_OPENED';
export const CLASS_FORM_SET_ADDONS_OPENED = 'CLASS_FORM_SET_ADDONS_OPENED';
export const CLASS_FORM_SET_DETAILS_OPENED = 'CLASS_FORM_SET_DETAILS_OPENED';
export const CLASS_FORM_SET_CUSTOM_FORM_OPENED = 'CLASS_FORM_SET_CUSTOM_FORM_OPENED';
export const CLASS_FORM_SUBMIT = 'CLASS_FORM_SUBMIT';
export const CLASS_FORM_PREFILL = 'CLASS_FORM_PREFILL';
export const SET_CLASS_ADDONS = 'SET_CLASS_ADDONS';
export const CLASS_FORM_DUPLICATE_TOGGLE = 'CLASS_FORM_DUPLICATE_TOGGLE';
export const CLASS_FORM_SET_IS_DRAFT = 'CLASS_FORM_SET_IS_DRAFT';


// WEBPACK FOOTER //
// ./src/store/modules/class-form/mutations.js